import { render, staticRenderFns } from "./SalesStatistics.vue?vue&type=template&id=5b25717a&scoped=true&"
import script from "./SalesStatistics.vue?vue&type=script&lang=js&"
export * from "./SalesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25717a",
  null
  
)

export default component.exports